import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import "../assets/css/style.css";
import "../assets/css/bootstrap.min.css";
import "../assets/css/font-awesome.min.css";
import "../assets/css/fontawesome-stars-o.min.css";
import "../assets/css/responsive-style.css";
import "../assets/css/colors/theme-color-1.css";
import "../assets/css/custom.css";
import "../assets/css/blogdetail.css";
import Loader from "../components/Loader";
import CategoryWidget from '../components/CategoryWidget';

const BlogDetail = () => {
  const { id } = useParams(); // Get blog ID from URL
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `http://localhost:5000/api/blogs/${id}`
        );
        setBlog(response.data);
      } catch (error) {
        console.error("Error fetching blog:", error);
      }
      setLoading(false);
    };
    fetchBlog();
  }, [id]);

  if (loading) return <Loader />;
  if (!blog) return <p>Blog not found</p>;

  const styles = {
    container: {
      paddingBottom: "30px",
      backgroundColor: "#f8f9fa",
      fontFamily: "Arial, sans-serif",
    },
    postItem: {
      background: "#fff",
      padding: "30px",
      borderRadius: "8px",
      boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)",
      marginBottom: "30px",
    },
    title: {
      fontSize: "28px",
      fontWeight: "bold",
      color: "#333",
      marginBottom: "15px",
    },
    meta: {
      fontSize: "14px",
      color: "#6c757d",
      display: "flex",
      gap: "15px",
    },
    img: {
      width: "100%",
      height: "auto",
      borderRadius: "8px",
      marginBottom: "20px",
    },
    content: {
      fontSize: "24px",
      color: "#555",
      lineHeight: "1.8",
    },
    tags: {
      marginTop: "20px",
      display: "flex",
      flexWrap: "wrap",
      gap: "10px",
    },
    tagItem: {
      background: "#007bff",
      color: "#fff",
      padding: "5px 10px",
      borderRadius: "5px",
      fontSize: "14px",
      textDecoration: "none",
    },
  };
  return (
    <div>
      {/* Posts Filter Bar Start */}
      <div className="posts--filter-bar style--1 hidden-xs">
        <div className="container">
          <ul className="nav">
            <li>
              <a href="#">
                <i className="fa fa-star-o" />
                <span>Featured News</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-heart-o" />
                <span>Most Popular</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-fire" />
                <span>Hot News</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-flash" />
                <span>Trending News</span>
              </a>
            </li>
            <li>
              <a href="#">
                <i className="fa fa-eye" />
                <span>Most Watched</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      {/* Posts Filter Bar End */}
      {/* News Ticker Start */}

      {/* Main Breadcrumb Start */}
      <div className="main--breadcrumb">
        <div className="container">
          <ul className="breadcrumb">
            <li>
              <a href="home-1.html" className="btn-link">
                <i className="fa fm fa-home" />
                Home
              </a>
            </li>
            <li>
              <a href="travel.html" className="btn-link">
                Travel
              </a>
            </li>
            <li className="active">
              <span>
                It is a long established fact that a reader will be distracted
                by
              </span>
            </li>
          </ul>
        </div>
      </div>
      {/* Main Breadcrumb End */}
      {/* Main Content Section Start */}
      <div className="main-content--section pbottom--30">
        <div className="container">
          <div className="row">
            {/* Main Content Start */}
            <div className="main--content col-md-8" data-sticky-content="true">
              <div className="sticky-content-inner">
                {/* Post Item Start */}
                <div className="post--item post--single post--title-largest pd--30-0">
                  <div className="post--cats">
                    <ul className="nav">
                      <li>
                        <span>
                          <i className="fa fa-folder-open-o" />
                        </span>
                      </li>
                      <li>
                        <a href="#">{blog.category}</a>
                      </li>
                    </ul>
                  </div>
                  <div className="post--info">
                    <ul className="nav meta">
                      <li>
                        <a href="#">{blog.author}</a>
                      </li>
                      <li>
                        <a href="#">{blog.publishDate}</a>
                      </li>
                    </ul>
                    <div className="title">
                      <h2 className="h4">{blog.title}</h2>
                    </div>
                  </div>
                  <div className="post--img">
                    <img
                      src={blog.image || "/img/technology-img/online-02@2x.jpg"} // Use default image if blog.image is not available
                      alt={blog.title || "Default Blog Image"}
                      className="img-fluid"
                      style={styles.img} 
                    />
                  </div>
                  <div
                    className="post--content"
                    style={{ textAlign: "justify" }}
                  >
                    <p>{blog.shortDescription}</p>
                    <h4>Description</h4>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: blog.longDescription1,
                      }}
                    />
                    <p>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: blog.longDescription2,
                        }}
                      />
                    </p>
                  </div>
                  
                </div>
              </div>
            </div>
            {/* Main Content End */}

            {/* Main Sidebar Start */}
            <div
              className="main--sidebar col-md-4 ptop--30 pbottom--30"
              data-sticky-content="true"
            >
              <div> <CategoryWidget /> </div>
                
                
                
                {/* Comment Form Start */}
                <div className="comment--form pd--30-0">
                  {/* Post Items Title Start */}
                  <div className="post--items-title">
                    <h2 className="h4">Leave A Comment</h2>
                    <i className="icon fa fa-pencil-square-o" />
                  </div>
                  {/* Post Items Title End */}
                  <div className="comment-respond">
                    <form action="#" data-form="validate">
                      <p>
                        Don’t worry ! Your email address will not be published.
                        Required fields are marked (*).
                      </p>
                      <div className="row">
                        <div className="col-sm-6">
                          <label>
                            <span>Comment *</span>
                            <textarea
                              name="comment"
                              className="form-control"
                              required
                              defaultValue={""}
                            />
                          </label>
                        </div>
                        <div className="col-sm-6">
                          <label>
                            <span>Name *</span>
                            <input
                              type="text"
                              name="name"
                              className="form-control"
                              required
                            />
                          </label>
                          <label>
                            <span>Email Address *</span>
                            <input
                              type="email"
                              name="email"
                              className="form-control"
                              required
                            />
                          </label>
                          <label>
                            <span>Website</span>
                            <input
                              type="text"
                              name="website"
                              className="form-control"
                            />
                          </label>
                        </div>
                        <div className="col-md-12">
                          <button type="submit" className="btn btn-primary">
                            Post a Comment
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                {/* Comment Form End */}
                <div className="post--items-title">
                    <h2 className="h4">Post Tags</h2>
                    <i className="icon fa fa-pencil-square-o" />
                  </div>
                <div className="post--tags">
                    <ul className="nav">
                      <li>
                        <span>
                          <i className="fa fa-tags" />
                        </span>
                      </li>
                      {blog.tags &&
                        blog.tags.map((tag, index) => (
                          <li key={index}>
                            <a href="#">{tag}</a>
                          </li>
                        ))}
                    </ul>
                  </div>
                {/* Widget Start */}
              
            </div>
          </div>
        </div>
      </div>
      <div id="backToTop">
        <a href="#">
          <i className="fa fa-angle-double-up"></i>
        </a>
      </div>
    </div>
  );
};
export default BlogDetail;
